








































import ShadowBigCard from '../atoms/ShadowBigCard.vue';
import TitleLabel from '../atoms/TitleLabel.vue';
import LoginButton from './LoginButton.vue';
import LineLoginButton from './LineLoginButton.vue';
import BuildingSelectBox from './BuildingSelectBox.vue';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { UserType } from '../../../src_server/biz/UserType';
import { WebUtils } from '../../utils/WebUtils';

@Component({
  components: {
    ShadowBigCard,
    TitleLabel,
    LoginButton,
    LineLoginButton,
    BuildingSelectBox,
  },
})
export default class TestUserLoginPanel extends Vue {
  mail = '';
  password = '';
  building = '';

  @Prop({ default: '' })
  public title!: string;

  @Prop({ default: 'adm' })
  public type!: UserType;

  mounted() {
    const linkLogin = this.$route.query.linkLogin as string;
    this.building = WebUtils.getQueryItem('building', location) || 'co01';

    console.log('test login Panel linkLogin ' + linkLogin);

    console.log('mounted panel ', this.type);
    switch (this.type) {
      case 'tea':
        this.mail = 'teacher@example.com';
        this.password = 'tea';
        break;
      case 'adm':
        this.mail = 'admin@example.com';
        this.password = 'admin';
        break;
      default:
        if (this.building === 'test') {
          this.mail = 'student2@example.com';
          this.password = 'stu';
        } else {
          this.mail = 'student@example.com';
          this.password = 'stu';
        }
        break;
    }
  }

  get showLineLogin() {
    return this.type === 'stu';
  }

  get teacherAndAdmin() {
    return this.type === 'tea' || this.type === 'adm';
  }

  public get typeJpeg() {
    let img = '';
    switch (this.building) {
      case 'co01':
        img = 'default.png';
        break;
      case 'da01':
        img = 'da-150x150.png';
        break;
      case 'test':
        img = 'test_logo.png';
    }
    return `/assets/logos/${img}`;
  }
}
